<template>
  <IconGeneric
    :iconUrl="require('../../assets/wheat.svg')"
    topText="Faible"
    bottomText="en gluten"
    :showAlmostWithout="true"
  ></IconGeneric>
</template>
<script>
  
import IconGeneric from './IconGeneric.vue';

export default {
  name: "IconFaibleGluten",
  setup() {},
  components: {
    IconGeneric,
  },
};
</script>

<style lang="scss">
  
</style>